<!--
  @Author: DKing
  @Desc: 首页
  @Date: 2019-07-11
-->
<template>
  <div class="page-main" id="homePage">
    <img class="img-title" src="../../../static/staticPages/pic_home_title.png" />
    <p class="home-text">欢迎登录{{oemInfo.clientName}}</p>
    <img src="../../../static/staticPages/pic_home_welcome.png" />
  </div>
</template>
<script>
  import {
    checkNull,
    getLocal,
    setLocal
  } from "../../filters/filters";
  export default {
    name: "index",
    data() {
      return {
         oemInfo:{},
      };
    },

    computed: {},

    created() {

      if(!checkNull(localStorage.getItem('resOemInfo'))){
        this.oemInfo = getLocal('resOemInfo');
      }
    },

    mounted() {},

    methods: {}
  };
  </script>
  <style>
  </style>
  <style lang="scss" scoped>
  @import "../../styles/variable";
  #homePage {
    padding-top: 160px;
    @include align-center;
    .img-title {
      width: 400px;
      margin-bottom: 24px;
    }
    .home-text {
      font-size: 24px;
      color: #272727;
      letter-spacing: 20px;
      margin-bottom: 72px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/staticPages/homePage.vue